import { ApolloError } from '@apollo/client';
import { GraphQLError } from 'graphql';

const ERROR_CODE_TRANSLATION_KEYS: Record<string, string | undefined> = {
  V101: 'BACKEND_ERROR_DEFINE_PRODUCTION_FOR_WHOLE_YEAR',
  V102: 'BACKEND_ERROR_DEFINE_MAXIMUM_FOR_WHOLE_YEAR',
  V103: 'BACKEND_ERROR_DEFINE_MINIMUM_FOR_WHOLE_YEAR',
  V104: 'BACKEND_ERROR_DEFINE_AUXILIARY_FOR_WHOLE_YEAR',
  V201: 'BACKEND_ERROR_PRODUCTION_BETWEEN_ZERO_AND_INSTALLED_POWER',
  V301: 'BACKEND_ERROR_MAXIMUM_GREATER_THAN_INSTALLED_POWER',
  V302: 'BACKEND_ERROR_MAXIMUM_LESS_THAN_MINIMUM',
  V303: 'BACKEND_ERROR_MINIMUM_LESS_THAN_ZERO',
  V401: 'BACKEND_ERROR_AUXILIARY_LESS_THAN_ZERO',
  V402: 'BACKEND_ERROR_AUXILIARY_GREATER_THAN_INSTALLED_POWER',
  V501: 'BACKEND_ERROR_TOO_MANY_DATA_POINTS_PER_MONTH',
  V601: 'BACKEND_ERROR_TEMPLATE_PARTS_NOT_DISTINCT',
  VF101: 'BACKEND_ERROR_NO_MARKET_LOCATION_PRODUCT_RELEASE',
  VF104: 'BACKEND_ERROR_LACKING_PRODUCT_RELEASE',
  VF201: 'BACKEND_ERROR_TIME_SLICE_RESOLUTION_MISMATCH',
  VF202: 'BACKEND_INVALID_FORECAST_RESOLUTION',
  VF301: 'BACKEND_ERROR_UNSUPPORTED_DATAPOINT_TYPE',
  VF501: 'BACKEND_ERROR_PRODUCTION_BETWEEN_ZERO_AND_INSTALLED_POWER',
  VF502: 'BACKEND_ERROR_BAND_BETWEEN_ZERO_AND_CALCULATED_FLEX_BAND',
  VF601: 'BACKEND_ERROR_UPPER_CONTROL_ENERGY_LIMIT_GREATER_THAN_TECHNICAL_LIMIT',
  VF602: 'BACKEND_ERROR_LOWER_CONTROL_ENERGY_LIMIT_LESS_THAN_TECHNICAL_LIMIT',
  VF603: 'BACKEND_ERROR_FCR_BAND_GREATER_INSTALLED_POWER',
  VF604: 'BACKEND_ERROR_FCR_BAND_LESS_THAN_ZERO',
  VF605: 'BACKEND_ERROR_FCR_BAND_GREATER_THAN_FCR_LIMITS',
  VF606: 'BACKEND_ERROR_FCR_BAND_GREATER_THAN_BAND_LIMIT',
  VF607: 'BACKEND_ERROR_FCR_BAND_GREATER_INSTALLED_POWER_MINUS_PRODUCTION',
  VF608: 'BACKEND_ERROR_FCR_BAND_GREATER_THAN_PRODUCTION',
  VF609: 'BACKEND_ERROR_FCR_BAND_GREATER_THAN_PRODUCTION_MINUS_LOWER_LIMIT',
  VF610: 'BACKEND_ERROR_FCR_BAND_GREATER_THAN_UPPER_LIMIT_MINUS_PRODUCTION',
  VF611: 'BACKEND_ERROR_FCR_BAND_NOT_SYMMETRICAL',
  VF612: 'BACKEND_ERROR_FCR_LIMITS_NOT_SYMMETRICAL',
  VF613: 'BACKEND_ERROR_FCR_SINGLE_BAND_GREATER_THAN_INSTALLED_POWER',
  VF614: 'BACKEND_ERROR_FCR_LOWER_LIMIT',
  VF701: 'BACKEND_ERROR_MARKETING_DEADLINE',
  VF702: 'BACKEND_ERROR_DOWNTIME_DEADLINE',
  VF801: 'BACKEND_ERROR_MARKETED_FCR_BAND_VIOLATED',
  VF901: 'BACKEND_ERROR_TIME_SLICE_DUPLICATE_VALUES',
  IC101: 'BACKEND_ERROR_DATA_POINTS_ARE_INCOMPLETE',
  SCHEDULING_API_EXCEPTION: 'SHARED_ERROR_UNKNOWN',
  BAD_REQUEST: 'SHARED_ERROR_BAD_REQUEST',
  FORECAST_GAP: 'SCHEDULING_ERROR_FORECAST_GAP',
};

/**
 * Translates a GraphQL error into a translation key for the error message.
 * @param error
 * @link https://confluence.energy2market.de/pages/viewpage.action?spaceKey=ITS&title=Validierung+von+Prognosewerten+und+Fehlercodes
 */
export function getErrorTranslationKey(error: unknown): string {
  if (!(error instanceof ApolloError)) {
    return 'SHARED_ERROR_UNKNOWN';
  }

  const extension = error?.graphQLErrors[0]?.extensions ?? (error as unknown as GraphQLError).extensions;
  if (!extension) {
    return 'SHARED_ERROR_UNKNOWN';
  }

  if (!extension.errorCodes) {
    return (
      ERROR_CODE_TRANSLATION_KEYS[extension.code as string] ?? (extension.code as string) ?? 'SHARED_ERROR_UNKNOWN'
    );
  }

  return (
    ERROR_CODE_TRANSLATION_KEYS[(extension.errorCodes as Array<Record<'code', string | number>>)[0]?.code] ??
    'SHARED_ERROR_UNKNOWN'
  );
}
